import { BaseTranslation } from 'src/i18n/i18n-types';

export const navigation: BaseTranslation = {
  adLibrary: 'Inspire',
  boards: 'Concept',
  assets: 'Assets',
  insights: 'Insights',
  briefs: 'Briefs',
  openMenu: 'Open navigation menu',
};
